import type { ApiObject } from "@rudderstack/analytics-js";
import { RudderAnalytics } from "@rudderstack/analytics-js";

const analytics = new RudderAnalytics();
analytics.load(
  import.meta.env.VITE_SUPPORT_RUDDERSTACK_API_KEY as string,
  import.meta.env.VITE_SUPPORT_RUDDERSTACK_DATAPLANE_URL as string,
);

export const identify = (userId: string) => {
  analytics.identify(userId);
};

export const page = (name: string) => {
  analytics.page(name);
};

export const track = (event: string, properties?: ApiObject) => {
  analytics.track(event, properties);
};
